/*
 * Which letter templates are sick certificates (KIN-1954).
 *
 * `letter_template` has no category column — only `id`, `name` and `template` — so the only thing
 * that marks a sick-cert template is that its body uses `{{sickCert.*}}` placeholders. That is the
 * same signal the backend itself used when it renamed one of them (migration z_194:
 * `WHERE template LIKE '%{{sickCert.whatCanBeAttended}}%'`).
 *
 * The catch: `GET /lettertemplate?patientId=…` substitutes every variable before returning, and
 * `buildTemplateVariables` includes the `sickCert.*` keys — so on the list the sick-cert form
 * fetches, the placeholders have already been replaced and the signal is gone. The unscoped
 * `GET /lettertemplate` does not substitute, so the ids are read from that and applied to the
 * substituted list.
 *
 * This is a workaround for the missing category field, not a substitute for it. If templates ever
 * gain a real type, this file should go.
 */
const SICK_CERT_PLACEHOLDER = "{{sickCert.";

export const isSickCertTemplate = (template) =>
  typeof template?.template === "string" &&
  template.template.includes(SICK_CERT_PLACEHOLDER);

/**
 * The sick-cert templates among `templates`, identified by `rawTemplates`.
 *
 * Falls back to every template when the raw list cannot say — it has not loaded, the request
 * failed, or no template uses the placeholders at all. An empty picker would be worse than an
 * unfiltered one: it would leave the GP with no way to apply any template.
 */
export const selectSickCertTemplates = (templates, rawTemplates) => {
  const sickCertIds = new Set(
    (rawTemplates ?? []).filter(isSickCertTemplate).map((template) => template.id)
  );

  if (sickCertIds.size === 0) return templates ?? [];

  return (templates ?? []).filter((template) => sickCertIds.has(template.id));
};
